import React, {useState} from 'react';
import Modal from 'react-modal';
import styles from './CancelPaymentPopUp.module.css';
import Button from "../../../components/common/button/Button";

interface CancelPaymentPopUpProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (reason: string, amount?: number) => void;
    totalAmount: number;  // 전체 결제 금액 추가
}

//결제 취소 팝업
const CancelPaymentPopUp: React.FC<CancelPaymentPopUpProps> = ({
                                                                   isOpen,
                                                                   onClose,
                                                                   onConfirm,
                                                                   totalAmount
                                                               }) => {
    const [reason, setReason] = useState('');
    const [isPartialCancel, setIsPartialCancel] = useState(false);
    const [cancelAmount, setCancelAmount] = useState<number>(totalAmount);

    //결제 취소 로직
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        //취소 사유 필수 기입
        if (!reason.trim()) return;
        //부분 취소 시 금액은 0 초과, 총액 미만
        if (isPartialCancel && (cancelAmount <= 0 || cancelAmount > totalAmount)) return;
        onConfirm(reason, isPartialCancel ? cancelAmount : totalAmount);
        setReason('');
        setIsPartialCancel(false);
        setCancelAmount(totalAmount);
    };

    //부분 취소
    const handlePartialCancelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIsPartialCancel(e.target.checked);
        setCancelAmount(totalAmount);
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className={styles.modal}
            overlayClassName={styles.overlay}
        >
            <div className={styles.container}>
                <h2 className={styles.title}>결제 취소</h2>
                <form onSubmit={handleSubmit}>
                    <div className={styles.checkboxContainer}>
                        <label>
                            {/*부분 취소 선택*/}
                            <input
                                type="checkbox"
                                checked={isPartialCancel}
                                onChange={handlePartialCancelChange}
                            />
                            <span className={styles.checkboxLabel}>부분 취소</span>
                        </label>
                    </div>

                    {/*부분 취소 시 취소 금액 선택*/}
                    {isPartialCancel && (
                        <div className={styles.amountContainer}>
                            <label className={styles.amountLabel}>취소 금액</label>
                            <input
                                type="number"
                                value={cancelAmount === 0 ? '' : cancelAmount}
                                onChange={(e) => setCancelAmount(Number(e.target.value))}
                                max={totalAmount}
                                min={1}
                                className={styles.amountInput}
                            />
                            <span className={styles.amountUnit}>원</span>
                        </div>
                    )}

                    {/*취소 사유 입력*/}
                    <textarea
                        className={styles.textarea}
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="취소 사유를 입력하세요"
                        required
                    />
                    <div className={styles.buttons}>
                        {/*취소 버튼*/}
                        <Button
                            type="submit"
                            variant="primary"
                            size="small"
                            disabled={!reason.trim() || (isPartialCancel && (cancelAmount <= 0 || cancelAmount > totalAmount))}
                        >
                            취소
                        </Button>
                        {/*팝업 닫기 버튼*/}
                        <Button
                            type="button"
                            variant="secondary"
                            size="small"
                            onClick={onClose}
                        >
                            닫기
                        </Button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};

export default CancelPaymentPopUp;